/*
    find page settings from our dottie meta element
*/
export function pageSettings(metaId) {

    const elm = document.getElementById(metaId);

    if (elm) {

        /*
            this json will contain the following:
                pageTitle = ''
                host = ''
                key = ''
                region = 0
                location = 0
                categories = []
                grades = []
                quickFilters = []
                eventsPage = false
                tracksPage = false
                hideRegionFilters = 0
        */
        const json = elm.getAttribute('content');

        const parsed = JSON.parse(json);

        return parsed;

    }

}
